import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-358c8a2a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "card" }
const _hoisted_3 = { class: "card-body row fv-row" }
const _hoisted_4 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_5 = { class: "fv-plugins-message-container" }
const _hoisted_6 = { class: "fv-help-block" }
const _hoisted_7 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_8 = { class: "d-flex align-items-center text-gray-600 mb-2" }
const _hoisted_9 = { class: "fv-plugins-message-container" }
const _hoisted_10 = { class: "fv-help-block" }
const _hoisted_11 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_12 = { class: "d-flex align-items-center text-gray-600 mb-2" }
const _hoisted_13 = { class: "required" }
const _hoisted_14 = { class: "fv-plugins-message-container" }
const _hoisted_15 = { class: "fv-help-block" }
const _hoisted_16 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_17 = { class: "d-flex align-items-center text-gray-600 mb-2" }
const _hoisted_18 = { class: "required" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_22 = { class: "d-flex align-items-center text-gray-600 mb-2" }
const _hoisted_23 = { class: "required" }
const _hoisted_24 = { class: "fv-plugins-message-container" }
const _hoisted_25 = { class: "fv-help-block" }
const _hoisted_26 = { class: "col-12 col-md-6 mb-3" }
const _hoisted_27 = { class: "d-flex align-items-center text-gray-600 mb-2" }
const _hoisted_28 = { class: "required" }
const _hoisted_29 = { class: "fv-plugins-message-container" }
const _hoisted_30 = { class: "fv-help-block" }
const _hoisted_31 = { class: "row g-3" }
const _hoisted_32 = { class: "col-12" }
const _hoisted_33 = {
  type: "submit",
  ref: "submitButtonRegister",
  class: "btn btn-success w-100 mb-5 flex-fill"
}
const _hoisted_34 = { class: "indicator-label" }
const _hoisted_35 = { class: "indicator-progress" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneInput = _resolveComponent("PhoneInput")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createBlock(_component_Form, {
    class: "form w-100",
    onSubmit: _ctx.onSubmitRegister,
    "validation-schema": _ctx.register
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_PhoneInput, { onPhoneObject: _ctx.handlePhone }, null, 8, ["onPhoneObject"]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "mobile"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, [
                _createElementVNode("span", null, _toDisplayString(_ctx.translate("email")), 1)
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-sm",
                type: "email",
                placeholder: _ctx.translate('email'),
                name: "email",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "email"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("label", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.translate("name")), 1)
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-sm",
                type: "text",
                placeholder: _ctx.translate('name'),
                name: "first_name",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "first_name"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("label", _hoisted_17, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.translate("last name")), 1)
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-sm",
                type: "text",
                placeholder: _ctx.translate('last name'),
                name: "last_name",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "last_name"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, [
                _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.translate("password")), 1)
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-sm",
                type: "password",
                placeholder: _ctx.translate('password'),
                name: "password",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "password"
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("label", _hoisted_27, [
                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.translate("confirm password")), 1)
              ]),
              _createVNode(_component_Field, {
                class: "form-control form-control-sm",
                type: "password",
                placeholder: _ctx.translate('confirm password'),
                name: "password_confirmation",
                autocomplete: "off"
              }, null, 8, ["placeholder"]),
              _createElementVNode("div", _hoisted_29, [
                _createElementVNode("div", _hoisted_30, [
                  _createVNode(_component_ErrorMessage, {
                    class: "fs-9",
                    name: "password_confirmation"
                  })
                ])
              ])
            ]),
            _createVNode(_component_Field, {
              class: "form-control form-control-sm",
              type: "hidden",
              name: "country_id",
              value: "IR"
            }),
            _createVNode(_component_Field, {
              class: "form-control form-control-sm",
              type: "hidden",
              name: "type",
              value: "user"
            }),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("button", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.translate("register")), 1),
                  _createElementVNode("span", _hoisted_35, [
                    _createTextVNode(_toDisplayString(_ctx.translate("please wait")) + " ", 1),
                    _hoisted_36
                  ])
                ], 512)
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onSubmit", "validation-schema"]))
}